module.exports = __webpack_public_path__ + "ac14e13a68e31bfb96c2b70dce90c8dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/payment/social-5.jpg
// module id = ./assets/images/payment/social-5.jpg
// module chunks = 0